export default class Video {
    static handle(host, name) {
        let link = host + '/v/' + name

        return link
    }
}
